import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const profitApi = {
  findAll: (year: number): AxiosPromise<any> =>
    request({
      url: "/v1/admin/profit",
      params: { year },
    }),
};
